import {
  SET_RESULT_DATA,
  SET_FONT_PREVIEW_INPUT_DATA,
  SET_FONT_PREVIEW_SLIDER_VALUE,
  SET_RESULT_REQUEST_FLAG,
  RESULTS_ERROR,
  SET_RESULTS_PAGE_NUMBER,
} from '../constants/actionTypes';


export default function update(state = {}, action) {
  if (action.type === SET_RESULT_DATA) {
    return Object.assign({}, state, { resultData: action.value });
  } else if (action.type === SET_FONT_PREVIEW_INPUT_DATA) {
    return Object.assign({}, state, { fontPreviewInputText: action.value });
  } else if (action.type === SET_FONT_PREVIEW_SLIDER_VALUE) {
    return Object.assign({}, state, { fontPreviewSliderValue: action.value });
  } else if (action.type === RESULTS_ERROR) {
    return Object.assign({}, state, { errorCode: action.errorCode });
  } else if (action.type === SET_RESULT_REQUEST_FLAG) {
    return Object.assign({}, state, { isNewResultRequestNeeded: action.value });
  } else if (action.type === SET_RESULTS_PAGE_NUMBER) {
    return Object.assign({}, state, { resultsPageNumber: action.value });
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/result.js